import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

function FooterAvantLogo({ imageLink }) {
  const { url, image } = imageLink
  return (
    <Link to={url} data-event="home">
      <img src={image.file.url} alt={image.title} />
    </Link>
  )
}

FooterAvantLogo.propTypes = {
  imageLink: PropTypes.object.isRequired
}

export default FooterAvantLogo
